import { useEffect } from 'react';
import { useCheckoutCartId } from '@monofront/business/contexts';
import { sendMessageToMobile } from '@utils/mobile';

export const CheckoutCartIdSyncWithMobileApp = () => {
  const [cartId] = useCheckoutCartId();

  useEffect(() => {
    sendMessageToMobile('checkoutCartId', { checkoutCartId: cartId });
  }, [cartId]);

  return null;
};
